export default "__VITE_ASSET__879268f0__"